(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["honho-card-gallery"] && !Shopify.designMode) return;
  try {
    class HonhoCardGallery extends HTMLElement {
    connectedCallback() {
      this.controller?.abort();
      this.controller = new AbortController();
      this.image = this.querySelector('[data-hh-main-image]');
      const data = this.querySelector('[data-gallery-images]');
      if (!this.image || !data) return;
      try { this.images = JSON.parse(data.textContent); } catch { return; }
      if (this.images.length < 2) return;
      this.index = 0;
      this.request = 0;
      this.selectVariant(this.image.getAttribute('src'), this.image.alt, true);
      this.dataset.galleryReady = 'true';
      const options = { signal: this.controller.signal };
      this.addEventListener('pointerenter', (event) => {
        if (event.pointerType === 'mouse' && this.index === this.baseIndex) this.show(this.baseIndex + 1);
      }, options);
      this.addEventListener('pointerleave', (event) => {
        if (event.pointerType === 'mouse' && !this.pointer) this.show(this.baseIndex);
      }, options);
      this.addEventListener('click', (event) => {
        const arrow = event.target.closest('[data-gallery-step]');
        if (arrow) {
          event.preventDefault(); event.stopPropagation();
          this.show(this.index + Number(arrow.dataset.galleryStep), true);
        } else if (Date.now() < (this.suppressClickUntil || 0) && event.target.closest('[data-gallery-link]')) {
          event.preventDefault(); event.stopPropagation();
        }
      }, options);
      this.addEventListener('keydown', (event) => {
        if (!event.target.closest('[data-gallery-link], [data-gallery-step]')) return;
        if (event.key !== 'ArrowLeft' && event.key !== 'ArrowRight') return;
        event.preventDefault(); event.stopPropagation();
        this.show(this.index + (event.key === 'ArrowRight' ? 1 : -1), true);
      }, options);
      this.addEventListener('dragstart', (event) => {
        if (event.target.closest('[data-gallery-link]')) event.preventDefault();
      }, options);
      this.addEventListener('pointerdown', (event) => {
        if (event.button !== 0 || !event.target.closest('[data-gallery-link]')) return;
        this.pointer = { id: event.pointerId, x: event.clientX, y: event.clientY, swiping: false };
      }, options);
      this.addEventListener('pointermove', (event) => {
        if (!this.pointer || this.pointer.id !== event.pointerId) return;
        const x = Math.abs(event.clientX - this.pointer.x);
        const y = Math.abs(event.clientY - this.pointer.y);
        if (!this.pointer.swiping && y > 12 && y > x) { this.pointer = null; return; }
        if (x > 16 && x > y * 1.5) {
          this.pointer.swiping = true;
          this.setPointerCapture(event.pointerId);
          event.preventDefault();
        }
      }, options);
      this.addEventListener('pointerup', (event) => {
        const pointer = this.pointer;
        this.pointer = null;
        if (!pointer || pointer.id !== event.pointerId) return;
        if (this.hasPointerCapture(event.pointerId)) this.releasePointerCapture(event.pointerId);
        if (pointer.swiping) {
          this.suppressClickUntil = Date.now() + 500;
          const delta = event.clientX - pointer.x;
          if (Math.abs(delta) >= 36) this.show(this.index + (delta < 0 ? 1 : -1), true);
        }
      }, options);
      this.addEventListener('pointercancel', () => { this.pointer = null; }, options);
    }

    disconnectedCallback() { this.controller?.abort(); this.request++; }

    key(source) {
      const url = new URL(source, window.location.href);
      url.searchParams.delete('width'); url.searchParams.delete('height');
      return url.href;
    }

    selectVariant(source, alt, initial = false) {
      if (!this.image || !this.images) return;
      let index = this.images.findIndex((image) => this.key(image.src) === this.key(source));
      if (index < 0) {
        index = this.images.length;
        this.images.push({ src: source, alt, width: this.image.width, height: this.image.height });
      }
      this.baseIndex = index;
      if (initial) {
        this.index = index;
        this.dataset.galleryIndex = String(index + 1);
        this.querySelector('[data-gallery-count]').textContent = `${index + 1} / ${this.images.length}`;
      } else this.show(index);
    }

    show(index, announce = false) {
      this.index = (index + this.images.length) % this.images.length;
      const image = this.images[this.index];
      const request = ++this.request;
      const current = this.index + 1;
      const preview = new Image();
      const apply = () => {
        if (request !== this.request || !this.isConnected) return;
        const widths = [240, 360, 480, 720, 900];
        this.image.srcset = widths.map((width) => {
          const url = new URL(image.src, window.location.href);
          url.searchParams.set('width', String(width));
          return `${url.href} ${width}w`;
        }).join(', ');
        this.image.src = image.src;
        this.image.alt = image.alt || '';
        this.dataset.galleryIndex = String(current);
        this.querySelector('[data-gallery-count]').textContent = `${current} / ${this.images.length}`;
        if (announce) this.querySelector('[data-gallery-status]').textContent = this.dataset.galleryLabel.replace('[current]', String(current)).replace('[total]', String(this.images.length));
      };
      preview.onload = apply;
      preview.src = image.src;
      if (preview.complete && preview.naturalWidth) apply();
    }
  }
  if (!customElements.get('honho-card-gallery')) customElements.define('honho-card-gallery', HonhoCardGallery);
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["honho-minimum-order"] && !Shopify.designMode) return;
  try {
    class HonhoMinimumOrder extends HTMLElement {
    connectedCallback() {
      this.dialog = this.querySelector('dialog');
      this.controller = new AbortController();
      const options = { signal: this.controller.signal };
      this.pendingUpdates = new Set();
      this.cartVersion = 0;
      this.quantityChangedAt = 0;
      const captureOptions = { ...options, capture: true };
      document.addEventListener('click', this.onCheckoutClick, captureOptions);
      document.addEventListener('submit', this.onCheckoutSubmit, captureOptions);
      window.addEventListener('pageshow', (event) => {
        if (!event.persisted) return;
        this.checkoutPending = false;
        if (this.checkoutTrigger instanceof HTMLButtonElement) this.checkoutTrigger.disabled = false;
        this.checkoutTrigger?.removeAttribute('aria-busy');
      }, options);
      document.addEventListener('quantity-selector:update', (event) => {
        if (event.detail?.cartLine) this.quantityChangedAt = Date.now();
      }, captureOptions);
      import('@shopify/events').then(({ StandardEvents }) => {
        if (this.controller.signal.aborted) return;
        for (const name of [StandardEvents.cartLinesUpdate, StandardEvents.cartDiscountUpdate, StandardEvents.cartNoteUpdate]) {
          document.addEventListener(name, this.trackCartUpdate, captureOptions);
        }
      }).catch(() => {});
      this.addEventListener('click', (event) => {
        if (event.target.closest('[data-minimum-close]') || event.target === this.dialog) this.dialog.close();
      }, options);
      this.dialog.addEventListener('close', () => {
        if (this.returnFocus?.isConnected) this.returnFocus.focus({ preventScroll: true });
      }, options);
    }

    disconnectedCallback() { this.controller?.abort(); }

    trackCartUpdate = (event) => {
      this.cartVersion += 1;
      if (!event.promise) return;
      const update = Promise.resolve(event.promise);
      this.pendingUpdates.add(update);
      const settled = () => { this.pendingUpdates.delete(update); this.cartVersion += 1; };
      update.then(settled, settled);
    };

    onCheckoutClick = (event) => {
      if (!(event.target instanceof Element)) return;
      const trigger = event.target.closest('[data-honho-cart-checkout], a[href]');
      if (!trigger) return;
      if (trigger instanceof HTMLAnchorElement) {
        const url = new URL(trigger.href, window.location.href);
        if (url.origin !== window.location.origin || !/\/checkout\/?$/.test(url.pathname)) return;
      }
      if (trigger.disabled) return;
      event.preventDefault();
      event.stopImmediatePropagation();
      this.checkCartCheckout(trigger);
    };

    onCheckoutSubmit = (event) => {
      if (!(event.target instanceof HTMLFormElement)) return;
      const submitter = event.submitter;
      const isCartCheckout = event.target.matches('.cart-form') && (!submitter || submitter.name === 'checkout');
      if (!isCartCheckout) return;
      event.preventDefault();
      event.stopImmediatePropagation();
      this.checkCartCheckout(submitter || event.target.querySelector('[name="checkout"]'));
    };

    async checkCartCheckout(trigger) {
      if (this.checkoutPending) return;
      this.checkoutPending = true;
      this.checkoutTrigger = trigger;
      const root = window.Shopify?.routes?.root || '/';
      const deadline = Date.now() + 15000;
      let cart;
      let navigating = false;
      if (trigger instanceof HTMLButtonElement) trigger.disabled = true;
      trigger?.setAttribute('aria-busy', 'true');
      try {
        while (Date.now() < deadline) {
          if (this.pendingUpdates.size || Date.now() - this.quantityChangedAt < 400 || document.querySelector('.cart-items-disabled')) {
            await new Promise(resolve => setTimeout(resolve, 50));
            continue;
          }
          const version = this.cartVersion;
          const response = await fetch(`${root}cart.js`, {
            headers: { Accept: 'application/json' }, credentials: 'same-origin', cache: 'no-store',
            signal: AbortSignal.timeout(Math.max(1, deadline - Date.now())),
          });
          if (!response.ok) throw new Error('Cart unavailable');
          cart = await response.json();
          if (version !== this.cartVersion || this.pendingUpdates.size || Date.now() - this.quantityChangedAt < 400) continue;
          if (cart.currency !== 'USD' || !Number.isFinite(cart.total_price) || !Array.isArray(cart.items)) throw new Error('Cart total unavailable');
          const cartComponent = trigger?.closest('cart-items-component');
          for (const row of cartComponent?.querySelectorAll('[data-key]') || []) {
            const input = row.querySelector('input[type="number"]');
            const line = cart.items.find(item => item.key === row.dataset.key);
            if (input && (!line || Number(input.value) !== line.quantity)) throw new Error('Cart quantity is still updating');
          }
          if (cart.total_price < 10000) {
            this.showMinimum(cart.total_price, trigger);
            return;
          }
          navigating = true;
          window.location.assign(`${root}checkout`);
          return;
        }
        throw new Error('Cart update timed out');
      } catch {
        this.showError(this.dataset.errorMessage, trigger);
      } finally {
        if (!navigating) {
          this.checkoutPending = false;
          if (trigger instanceof HTMLButtonElement) trigger.disabled = false;
          trigger?.removeAttribute('aria-busy');
        }
      }
    }


    showMinimum(total, trigger) {
      const money = new Intl.NumberFormat(document.documentElement.lang || 'en', { style: 'currency', currency: 'USD' });
      this.querySelector('[data-minimum-details]').hidden = false;
      this.querySelector('[data-minimum-error]').hidden = true;
      this.querySelector('[data-minimum-total]').textContent = money.format(total / 100);
      this.querySelector('progress').value = Math.min(10000, Math.max(0, total));
      this.querySelector('[data-minimum-remaining]').textContent = this.dataset.remainingTemplate.replace('[amount]', money.format(Math.max(0, 10000 - total) / 100));
      this.open(trigger);
    }

    showError(message, trigger) {
      this.querySelector('[data-minimum-details]').hidden = true;
      const error = this.querySelector('[data-minimum-error]');
      error.textContent = this.dataset.errorMessage;
      error.hidden = false;
      this.open(trigger);
    }

    open(trigger) {
      this.returnFocus = trigger;
      if (!this.dialog.open) this.dialog.showModal();
      this.querySelector('.hh-minimum-shop').focus({ preventScroll: true });
    }
  }
  if (!customElements.get('honho-minimum-order')) customElements.define('honho-minimum-order', HonhoMinimumOrder);
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["honho-tier-pricing-assets"] && !Shopify.designMode) return;
  try {
    (async () => {
  const { StandardEvents } = await import('@shopify/events');

  class HonhoTierPricing extends HTMLElement {
    connectedCallback() {
      this.abortController = new AbortController();
      this.section = this.closest('#quick-add-modal-content, .shopify-section');
      if (!this.section) return;
      this.prices = JSON.parse(this.querySelector('[data-hh-pricing-map]')?.textContent || '{}');
      this.variantId = this.dataset.variantId;
      this.buttons = [...this.querySelectorAll('[data-hh-qty]')];
      this.quantity = this.readQuantity();
      const options = { signal: this.abortController.signal };
      this.addEventListener('click', this.onTierClick, options);
      this.section.addEventListener('input', this.onQuantityInput, options);
      this.section.addEventListener('change', this.onQuantityInput, options);
      this.section.addEventListener('quantity-selector:update', this.onQuantityUpdate, options);
      this.section.addEventListener(StandardEvents.productSelect, this.onProductSelect, options);
      this.renderPrices();
    }

    disconnectedCallback() {
      this.abortController?.abort();
      cancelAnimationFrame(this.frame);
    }

    quantityInput() {
      return this.section?.querySelector('product-form-component input[name="quantity"], form[action*="/cart/add"] input[name="quantity"]');
    }

    readQuantity() {
      return Math.max(1, Number.parseInt(this.quantityInput()?.value, 10) || 1);
    }

    onTierClick = (event) => {
      const button = event.target.closest('[data-hh-qty]');
      if (!button || !this.contains(button)) return;
      const input = this.quantityInput();
      if (!input) return;
      const desired = Number(button.dataset.hhQty);
      const minimum = Number(input.min) || 1;
      const maximum = input.max ? Number(input.max) : Infinity;
      const increment = Number(input.step) || 1;
      const permitted = Math.min(maximum, Math.max(minimum, minimum + Math.ceil((desired - minimum) / increment) * increment));
      input.value = String(permitted);
      input.dispatchEvent(new Event('input', { bubbles: true }));
      input.dispatchEvent(new Event('change', { bubbles: true }));
      this.quantity = this.readQuantity();
      this.renderPrices();
    };

    onQuantityInput = (event) => {
      if (event.target !== this.quantityInput()) return;
      this.quantity = this.readQuantity();
      this.renderPrices();
    };

    onQuantityUpdate = (event) => {
      if (!event.target.contains(this.quantityInput())) return;
      this.quantity = this.readQuantity();
      this.renderPrices();
    };

    onProductSelect = (event) => {
      if (event.target.closest('product-card') || !event.promise) return;
      const quantity = this.readQuantity();
      const sequence = this.sequence = (this.sequence || 0) + 1;
      event.promise.then(({ detail }) => {
        if (!this.isConnected || sequence !== this.sequence) return;
        const replacement = detail.html?.querySelector('honho-tier-pricing');
        if (replacement) {
          this.prices = JSON.parse(replacement.querySelector('[data-hh-pricing-map]')?.textContent || '{}');
          this.dataset.productId = replacement.dataset.productId;
        }
        this.variantId = detail.resource?.id ? String(detail.resource.id) : '';
        this.quantity = quantity;
        cancelAnimationFrame(this.frame);
        this.frame = requestAnimationFrame(() => {
          if (!this.isConnected) return;
          const input = this.quantityInput();
          if (input) {
            input.value = String(quantity);
            input.dispatchEvent(new Event('change', { bubbles: true }));
          }
          this.renderPrices();
        });
      }).catch(() => {});
    };

    renderPrices() {
      const variant = this.prices[this.variantId];
      if (!variant) {
        this.buttons.forEach(button => { button.disabled = true; });
        this.querySelector('[data-hh-unit-price]').textContent = '—';
        this.querySelector('[data-hh-original]').hidden = true;
        return;
      }
      let active = 0;
      this.buttons.forEach((button, index) => {
        if (this.quantity >= Number(button.dataset.hhQty)) active = index;
        button.disabled = !variant.available;
        button.querySelector('[data-hh-option-price]').textContent = variant.prices[index];
      });
      this.buttons.forEach((button, index) => {
        button.classList.toggle('is-selected', index === active);
        button.setAttribute('aria-pressed', String(index === active));
      });
      this.dataset.selectedQuantity = String(this.quantity);
      this.dataset.selectedDiscount = this.buttons[active].dataset.hhDiscount;
      this.querySelector('[data-hh-unit-price]').textContent = variant.prices[active];
      const original = this.querySelector('[data-hh-original]');
      original.textContent = variant.prices[0];
      original.hidden = Number(this.buttons[active].dataset.hhDiscount) <= 0;
      const priceBlocks = [...this.section.querySelectorAll('product-price')].filter(el => String(el.dataset.productId) === String(this.dataset.productId));
      const sticky = this.section.querySelector('[data-testid="sticky-price-display"]');
      if (sticky) priceBlocks.push(sticky);
      priceBlocks.forEach(block => {
        const price = block.querySelector('[ref="priceContainer"] .price');
        if (!price) return;
        price.textContent = variant.prices[active];
        let base = block.querySelector('[data-hh-tier-original]');
        if (!base) {
          base = document.createElement('s');
          base.dataset.hhTierOriginal = '';
          base.className = 'hh-tier-original';
          price.before(base);
        }
        base.textContent = variant.prices[0];
        base.hidden = Number(this.buttons[active].dataset.hhDiscount) <= 0;
      });
    }
  }

  if (!customElements.get('honho-tier-pricing')) customElements.define('honho-tier-pricing', HonhoTierPricing);
  })();
  } catch(e) { console.error(e); }
})();

})();
